import React from 'react';
import Hotkeys from 'react-hot-keys';

export const ChangeDrawer = ({action}) => <Hotkeys keyName='ctrl+b' onKeyUp={action} />;

export const Logout = ({action}) => <Hotkeys keyName='ctrl+q' onKeyUp={action} />;

export const SearchFocus = ({action}) => <Hotkeys keyName='/' onKeyUp={action} />;

export const SubmitModal = ({action}) => <Hotkeys keyName='enter' onKeyUp={action} />;
